import { Resources } from '@ragu-components/ord-resources';

import { ExtensionList as ExtensionsList } from './ExtensionsList';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Extension } from '@ragu-components/ord-types';

export const extensionResource: OrdResourceProps = {
  key: Resources.extensions,
  name: Resources.extensions,
  list: <ExtensionsList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: Extension): string => record.number,
};
